import React from 'react'
import { Card, CardContent } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import Box from '@material-ui/core/Box'
import { useNonProfitCardStyles } from '../non-profit-card.styles'

export const NonProfitCardPlaceholder: React.FC = () => {
  const classes = useNonProfitCardStyles()

  return (
    <Card>
      <CardContent className={classes.cardContent}>
        <Box pt={0.5}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Skeleton
              animation="wave"
              variant="circle"
              width={60}
              height={60}
              className={classes.imgHolder}
            />
            <div className={classes.cardText}>
              <Skeleton
                animation="wave"
                width="80%"
                height={24}
                style={{ marginBottom: 8 }}
              />
              <div className={classes.cardCategoryLine}>
                <Skeleton
                  animation="wave"
                  width="40%"
                  height={16}
                  style={{ marginBottom: 4 }}
                />
                <Skeleton
                  animation="wave"
                  width="30%"
                  height={16}
                  style={{ marginLeft: 2, marginBottom: 4 }}
                />
              </div>
              <Skeleton animation="wave" width="100%" height={16} />
              <Skeleton animation="wave" width="90%" height={16} />
              <Skeleton animation="wave" width="70%" height={16} />
            </div>
          </div>
        </Box>
      </CardContent>
    </Card>
  )
}
